export default {
   English : 'https://www.healthcare.gov',
   Spanish : 'https://www.cuidadodesalud.gov',
}